<template>
  <div class="text-start" style="font-size: 18px">
    <span>機台：{{ maintainData.device }}</span>
  </div>
  <div class="text-start" style="font-size: 18px">
    <span>維修別：{{ maintainData.category == 3 ? "搶修" : "報修" }}</span>
  </div>
  <div class="text-start" style="font-size: 18px">
    <span>故障/異常描述：{{ maintainData.description }}</span>
  </div>
  <div class="text-start" style="font-size: 18px">
    <span
      >維修人員：<span
        class="py-1 px-2"
        style="background: #c8c9ca; min-width: max-content"
        >{{ maintainData.personnel }}</span
      ></span
    >
  </div>
  <div class="text-start" style="font-size: 18px">
    <span>維修時間：{{ maintainData.time }}</span>
  </div>
  <div class="text-start mb-3" style="font-size: 18px">
    <span>維修說明：</span>
    <div class="form-floating">
      <textarea
        class="form-control p-2"
        placeholder="Leave a comment here"
        id="floatingTextarea"
        style="height: 200px"
        v-model="textData"
      ></textarea>
    </div>
  </div>
  <div v-for="(file, index) in files" :key="index" class="file-input-row">
    <div class="text-start mb-3">
      <label :for="'formFile' + index" class="form-label"
        >附件{{ index + 1 }}：</label
      >
      <div class="input-group">
        <input
          class="form-control file-input"
          type="file"
          accept="image/jpeg, image/png, application/pdf"
          :id="'formFile' + index"
          :disabled="file !== null"
          @change="onFileChange(index, $event)"
          :aria-describedby="'inputGroupRemove' + index"
        />
        <button
          class="remove-btn"
          @click="removeFile(index)"
          v-if="file !== null"
          :id="'inputGroupRemove' + index"
        >
          <font-awesome-icon style="width: 25px" :icon="['fas', 'trash-can']" />
        </button>
      </div>
      <div class="text-start" style="color: #c8c9ca">僅能上傳圖片及PDF</div>
    </div>
  </div>
  <div class="gap-2 d-md-flex justify-content-md-end">
    <button
      type="button"
      class="btn p-0 me-2"
      style="
        color: #fff;
        background-color: #4b8c80;
        width: 6rem;
        height: 2rem;
        font-size: 1.125rem;
      "
      @click="cancelWrite"
    >
      取消
    </button>
    <button
      type="button"
      class="btn p-0"
      style="
        color: #fff;
        background-color: #4b8c80;
        width: 6rem;
        height: 2rem;
        font-size: 1.125rem;
      "
      @click="
        checkWrite(
          maintainData.abn_start_time,
          maintainData.deviceID,
          maintainData.dir,
          textData,
          files
        )
      "
    >
      確認
    </button>
  </div>
</template>

<script>
import { inject, ref } from "vue";
import store from "@/store";
export default {
  components: {},
  setup() {
    //dispatch
    const methods = {
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const fillInInstructions = inject("fillInInstructions");
    const maintainData = inject("maintainData");
    const commonMethods = inject("commonMethods");

    const completeWorkRowClick = commonMethods.completeWorkRowClick;
    const cancelWrite = commonMethods.cancelWrite;
    const checkWrite = commonMethods.checkWrite;

    const textData = ref("");

    const files = ref([null]); // Start with an empty file input

    const checkFileUploadType = (newFile) => {
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
      return !allowedTypes.includes(newFile.type) ? true : false;
    };

    const onFileChange = (index, event) => {
      const fileList = event.target.files;
      if (fileList.length > 0) {
        const newFile = fileList[0];
        const invalidFiles = checkFileUploadType(newFile);
        if (invalidFiles) {
          event.target.value = "";
          methods.setTimeoutAlert("不支援的檔案類型");
          return;
        }
        const existingFiles = files.value.filter((file) => file !== null); // Exclude null values

        // Check if the new file already exists in the existing files
        const isDuplicate = existingFiles.some(
          (file) => file.name === newFile.name && file.size === newFile.size
        );

        if (!isDuplicate) {
          files.value.splice(index, 1, newFile); // Replace the file at the specific index

          // Automatically add a new file input after a file is uploaded
          if (index === files.value.length - 1) {
            files.value.push(null); // null or an empty string to represent an empty file input
          }
        } else {
          // Show an error message for duplicate file
          methods.setTimeoutAlert("檔案已存在，請選擇不同的檔案。");
          // Clear the file input
          event.target.value = "";
        }
      } else {
        files.value[index] = null;
      }
    };

    const removeFile = (index) => {
      const fileInput = document.getElementById("formFile" + index);
      if (fileInput) {
        fileInput.value = null; // Clear the file input value
      }

      if (index !== files.value.length - 1) {
        // Check if it's not the last file
        files.value[index] = null;
        files.value.splice(index, 1);
        files.value.splice(index, 0, null); // Insert null to fill the gap
      } else {
        files.value.splice(index, 1); // Remove the last file directly
      }
    };

    return {
      fillInInstructions,
      maintainData,
      completeWorkRowClick,
      cancelWrite,
      checkWrite,
      textData,
      files,
      onFileChange,
      removeFile,
    };
  },
};
</script>

<style>
/* .file-input-row {
  display: flex;
  align-items: center;
}
 */
.remove-btn {
  background-color: #e9ecef;
  border: 1px solid #ced4da;
}
</style>
